import React from 'react'
import dayjs from 'dayjs'
import 'dayjs/locale/nb'
import Campaign from '../../../react4xp/components/Campaign'
import RichTextSection from '../../../react4xp/components/RichTextSection'
import EventDate from '../../../react4xp/components/EventDate'
import CountyMenu from '../../../react4xp/components/CountyMenu'
import type { ArticleLayoutProps } from './article-layout.d'
import CaptionSection from '../../../react4xp/components/CaptionSection'

function ArticleLayout({ 
  campaign, 
  body, 
  event,
  countyMenu,
  imageCaption,
  imageCopyright
}: ArticleLayoutProps) {
  const showdate = campaign.showdate
    ? dayjs(campaign.showdate).locale('nb').format('DD. MMM YYYY')
    : ''

  return (
    <>
      {countyMenu?.currentCountyLabel && countyMenu?.currentCountyHref && countyMenu?.currentCountyTarget && countyMenu?.countySubMenu && countyMenu?.countyMenu && (
        <CountyMenu
          currentCountyLabel={countyMenu.currentCountyLabel}
          currentCountyHref={countyMenu.currentCountyHref}
          currentCountyTarget={countyMenu.currentCountyTarget}
          countyItems={countyMenu.countySubMenu}
          menuItems={countyMenu.countyMenu}
        />
      )}
      <Campaign {...campaign} showdate={showdate} />
      {event && (
        <EventDate
          startDate={event.startDate}
          endDate={event.endDate}
          time={event.time}
          location={event.location}
        />
      )}
      <RichTextSection content={body || ''} />
      {(imageCaption || imageCopyright) && (
        <CaptionSection
          captionLabel='Stort bilde i toppen'
          caption={imageCaption}
          copyright={imageCopyright}
        />
      )}
    </>
  )
}

export default ArticleLayout
